import { render } from "./ManufacturerInventory.vue?vue&type=template&id=7d04a3e6"
import script from "./ManufacturerInventory.vue?vue&type=script&lang=js"
export * from "./ManufacturerInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__